// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"90989674","633":"b9c5c71c","816":"094f5304"}[chunkId] + ".chunk.js";
};